'use client';

import { useEffect } from 'react';

import {
  initializeNotifications,
  setupNotificationPermissionRequest,
} from 'src/utils/notification';

/**
 * Component to initialize desktop notifications on app load
 * This should be placed high in the component tree
 */
export default function NotificationInitializer() {
  useEffect(() => {
    // Initialize notifications when app loads
    const initNotifications = async () => {
      try {
        await initializeNotifications();
        setupNotificationPermissionRequest();
      } catch (error) {
        console.error('Failed to initialize notifications:', error);
      }
    };

    initNotifications();
  }, []);

  // This component doesn't render anything
  return null;
}
